/** @format */

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'pdp-bv-shoppable-image',
	templateUrl: './bv-shoppable-image.component.html',
	styleUrl: './bv-shoppable-image.component.scss',
	imports: [CommonModule]
})
export class ShoppableImageComponent {}
